import * as React from 'react'
import UsersActions from './Actions'
import { IconButton, Tooltip } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import CheckIcon from '@mui/icons-material/Check'

function CopyIdCell({ value }) {
  const [copied, setCopied] = React.useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(value).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    })
  }

  return (
    <Tooltip title={copied ? '¡Copiado!' : 'Copiar ID'} placement="right">
      <IconButton size="small" onClick={handleCopy} sx={{ color: copied ? 'success.main' : 'text.secondary' }}>
        {copied ? <CheckIcon sx={{ fontSize: 16 }} /> : <ContentCopyIcon sx={{ fontSize: 16 }} />}
      </IconButton>
    </Tooltip>
  )
}

export const getColumns = (rowId, setRowId, roleOptions, roleMap, onRequestDelete, onRequestReset) => [
  {
    field: 'id',
    headerName: 'ID',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    filterable: false,
    renderCell: params => <CopyIdCell value={params.value} />,
  },
  {
    field: 'nombre',
    headerName: 'Nombre',
    headerAlign: 'center',
    flex: 1,
    minWidth: 110,
    editable: true,
  },
  {
    field: 'apellido',
    headerName: 'Apellido',
    headerAlign: 'center',
    flex: 1,
    minWidth: 110,
    editable: true,
  },
  {
    field: 'email',
    headerName: 'Email',
    headerAlign: 'center',
    flex: 2,
    minWidth: 190,
    editable: true,
  },
  {
    field: 'habilitado',
    headerAlign: 'center',
    headerName: 'Habilitado',
    type: 'boolean',
    editable: true,
  },
  {
    field: 'esPublico',
    headerAlign: 'center',
    headerName: 'Público',
    type: 'boolean',
    editable: true,
  },
  {
    field: 'idRol',
    headerName: 'Rol',
    headerAlign: 'center',
    align: 'center',
    type: 'singleSelect',
    valueOptions: roleOptions,
    renderCell: params => roleMap[params.value] ?? params.value,
    width: 130,
    editable: true,
  },
  {
    field: 'actions',
    headerAlign: 'center',
    headerName: 'Acciones',
    type: 'actions',
    width: 170,
    renderCell: params => <UsersActions {...{ params, rowId, setRowId, onRequestDelete, onRequestReset }} />,
  },
]
